export default {"src":"/_next/static/media/email_black_24dp.3302680d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};